import classNames from 'classnames';
import SidebarHeader from './SidebarHeader';
import SidebarMenu from './SidebarMenu';
import { useSelector } from 'react-redux';
import { selectIsProUser } from '../../selectors/user';
import { isBlackFridayActive } from '../../utilities';
import BlackFridayPromotionGraphic from '../PromotionGraphic/BlackFridayPromotionGraphic';

type SidebarProps = {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  onTopMenuClick: (value: boolean) => void;
};

const Sidebar = ({
  className,
  isOpen,
  onClose,
  onTopMenuClick,
}: SidebarProps) => {
  const isProUser = useSelector(selectIsProUser);

  return (
    <aside className={classNames('sidebar', isOpen ? 'open' : '', className)}>
      <div className="wrapper">
        <SidebarHeader isOpen={isOpen} onClose={onClose} />
        <div className="overflow-y-auto flex-1 flex flex-col hide-scrollbar">
          <SidebarMenu isOpen={isOpen} onTopMenuClick={onTopMenuClick} />
        </div>

        {isProUser && isBlackFridayActive() && (
          <div className="mt-24 mb-6 flex items-end justify-center">
            <BlackFridayPromotionGraphic isSidebarOpen={isOpen} />
          </div>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;
